{
  "title": "Сповіщення",
  "loading": "Завантаження…",
  "empty": "Поки що нічого нового.",
  "markAllRead": "Позначити всі як прочитані",
  "unreadCount_one": "Сповіщення, {{count}} непрочитане",
  "unreadCount_few": "Сповіщення, {{count}} непрочитані",
  "unreadCount_many": "Сповіщення, {{count}} непрочитаних",
  "seeAll": "Усі сповіщення",
  "inbox": {
    "title": "Сповіщення",
    "description": "Усе, що школа вам надіслала.",
    "unreadOnly": "Лише непрочитані",
    "kind": "Тип",
    "allKinds": "Усі типи",
    "open": "Відкрити",
    "unread": "Непрочитане",
    "markedAllRead": "Усі сповіщення позначено як прочитані.",
    "clearFilters": "Скинути фільтри"
  },
  "kinds": {
    "homework_assigned": "Призначено домашнє завдання",
    "homework_graded": "Оцінено домашнє завдання",
    "homework_returned": "Домашнє завдання повернуто",
    "test_assigned": "Призначено тест",
    "attempt_graded": "Тест оцінено",
    "announcement": "Оголошення",
    "message": "Нове повідомлення",
    "invitation": "Запрошення",
    "project_assigned": "Призначено проєкт",
    "project_graded": "Проєкт оцінено",
    "due_soon": "Наближається термін здачі"
  },
  "preferences": {
    "title": "Налаштування сповіщень",
    "description": "Як школа з вами зв'язується. Ці налаштування діють у межах цієї школи.",
    "inApp": "Показувати сповіщення в застосунку",
    "inAppHint": "Сповіщення завжди зберігаються в застосунку; це налаштування керує лише лічильником і дзвіночком.",
    "email": "Надсилати мені листи",
    "emailHint": "Якщо вимкнути, листи не надходитимуть узагалі — незалежно від частоти.",
    "digest": "Частота листів",
    "digestModes": {
      "instant": "Одразу",
      "daily": "Щоденний дайджест",
      "weekly": "Щотижневий дайджест",
      "off": "Без листів"
    },
    "parentNote": "Для батьків типово увімкнено щотижневий дайджест, щоб шкільний тиждень приходив одним листом, а не тридцятьма. Це можна змінити тут будь-коли.",
    "saved": "Налаштування збережено.",
    "loading": "Завантажуємо налаштування…"
  },
  "emptyText": "Тут з’являються домашні завдання, оцінки, оголошення та повідомлення — щойно вони надходять.",
  "emptyFiltered": {
    "title": "За цими фільтрами нічого немає",
    "text": "Сповіщень цього типу зараз немає. Скиньте фільтри, щоб побачити всі."
  }
}
